import { FileItemBase as e } from "./file-item-base.mjs";
import { CircularProgress as t } from "./circular-progress.mjs";
import "react";
import { Fragment as n, jsx as r, jsxs as i } from "react/jsx-runtime";
import { XIcon as a } from "@systemeio/icons";
//#region src/components/file-item/file-item-compact.tsx
function o(o) {
	return /* @__PURE__ */ r(e, {
		...o,
		childrenWrapper: /* @__PURE__ */ i(n, { children: [o.isError && /* @__PURE__ */ r("div", {
			className: "bg-alpha-gray-alpha-gray-25 absolute top-0 left-0 flex h-full w-full items-center justify-center rounded-md backdrop-blur-md",
			children: /* @__PURE__ */ r(a, {
				"aria-hidden": !0,
				className: "text-icon-error size-5"
			})
		}), o.isLoading && /* @__PURE__ */ r("div", {
			className: "bg-alpha-gray-alpha-gray-25 absolute top-0 left-0 flex h-full w-full items-center justify-center rounded-md backdrop-blur-md",
			children: /* @__PURE__ */ r(t, { progress: o.progress ?? 0 })
		})] })
	});
}
//#endregion
export { o as FileItemCompact };
